(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};

  function updateStock(ctx, variant) {
    const inventoryInfo = ctx.data.variantInventory ? ctx.data.variantInventory[variant.id] : null;
    const quantityFromMap = inventoryInfo ? Number(inventoryInfo.inventory_quantity) : NaN;
    const quantityFromVariant = Number(variant.inventory_quantity);
    const hasMappedQuantity = Number.isFinite(quantityFromMap);
    const hasVariantQuantity = Number.isFinite(quantityFromVariant);

    let isAvailable = false;

    if (hasMappedQuantity) {
      isAvailable = quantityFromMap > 0;
    } else if (hasVariantQuantity) {
      isAvailable = quantityFromVariant > 0;
    } else if (typeof variant.available === 'boolean') {
      isAvailable = variant.available;
    }

    if (ctx.stockIndicator) {
      if (isAvailable) {
        ctx.stockIndicator.textContent = '';
        ctx.stockIndicator.style.color = '#999';
      } else {
        ctx.stockIndicator.textContent = 'Out of stock';
        ctx.stockIndicator.style.color = '#d32f2f';
      }
    }

    if (ctx.addToCartBtn) {
      ctx.addToCartBtn.disabled = !isAvailable;
      ctx.addToCartBtn.textContent = isAvailable ? 'ADD TO CART' : 'OUT OF STOCK';
    }

  }

  TGLProduct.updateStock = updateStock;
})();
